import { InputLabel, TextField } from '@mui/material';
import React from 'react';

const GroupTitleSelector = (props) => {
    const { serviceData, handleGroupTitleEnChange, handleGroupTitleRoChange } = props;

    return (
        <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center', marginTop: '5px'}}>
            <InputLabel>Group Title Title</InputLabel>
            <div>
                <TextField label="Group Title (English)" size="small" value={serviceData.group_title_en} onChange={handleGroupTitleEnChange} />
                <TextField label="Group Title (Romanian)" size="small" value={serviceData.group_title_ro} onChange={handleGroupTitleRoChange} />
            </div>
        </div>
    );
};

export default GroupTitleSelector;